







































































































































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import PieChart from '../../../Charts/PieChart/PieChart.vue'
import { PieChartDataRecord } from '../../../Charts/PieChart/types'
import Ratio from '../../../Charts/ratio.vue'
import { UseFields } from '../../../Pi'
import { FieldData, SelectOptionData } from '../../../Pi/types'
import { BotUsersConfig } from '../../types'
import StatValueCard from './StatValueCard.vue'
import { UsersReport } from './types'

@Component({
  components: {
    StatValueCard,
    Ratio,
    PieChart,
  },
  data() {
    return {
      isMobile,
    }
  }
})
export default class UsersStatistics extends UseFields {
  @Prop() getUtms!: BotUsersConfig['getUtms']

  @Prop() getReports!: BotUsersConfig['getUsersReports']

  @Prop() initUtm!: string | null

  utms: Array<SelectOptionData> = []

  currentUtm = ''

  stat: UsersReport | null = null

  isLoading = false

  chartTemplate = 0

  langChartData: Array<PieChartDataRecord> = []

  @Emit()
  resetInitUtm() {
    return null
  }

  @Watch('initUtm')
  onInitUtmChange(value: string | null) {
    this.setCurrentUtm(value)
  }

  setCurrentUtm(value: string | null) {
    if (value) {
      const utm = this.utms.find(u => u.label === value)

      if (utm) {
        this.setStat(utm.value)
          .then(() => {
            this.currentUtm = utm.value
            this.resetInitUtm()
          })
      }
    }
  }

  getIcon(field: keyof UsersReport['lastMonth'] | keyof UsersReport['botState']): string {
    if (field === 'last_activity') {
      return 'fire'
    } else if (field === 'last_entered') {
      return 'import'
    } else if (field === 'left') {
      return 'close-circle'
    } else if (field === 'disabled') {
      return 'user-delete'
    } else if (field === 'total') {
      return 'team'
    } else if (field === 'active') {
      return 'user-add'
    } else {
      return ''
    }
  }

  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => {
      arg.model[arg.key] = val

      this.setStat(val)
    }
    return arg
  }

  async setStat(utm?: string): Promise<void> {
    this.isLoading = true

    try {
      const stat = utm ? await this.getReports(utm) : await this.getReports()

      this.langChartData = [
        {
          data: stat.russian,
          name: this.$t('users_report_statistics_lang_ru').toString()
        },
        {
          data: stat.english,
          name: this.$t('users_report_statistics_lang_en').toString()
        },
        {
          data: stat.arabic,
          name: this.$t('users_report_statistics_lang_ar').toString()
        },
        {
          data: stat.han,
          name: this.$t('users_report_statistics_lang_hn').toString()
        },
      ]

      this.stat = {
        lang: {
          ru: stat.russian,
          en: stat.english,
          ar: stat.arabic,
          hn: stat.han
        },
        avatar: {
          has: stat.hasAvatar,
          no: stat.noAvatar
        },
        gender: {
          male: stat.male,
          female: stat.female
        },
        botState: {
          total: stat.active + stat.disabled,
          active: stat.active,
          disabled: stat.disabled,
        },
        lastMonth: {
          last_activity: stat.last_activity,
          last_entered: stat.last_entered,
          left: stat.last_left,
        }
      }
    } catch (e) {
      errorNotificationWrapper(this.$t('error').toString(), e)
    } finally {
      this.chartTemplate += 1
      this.isLoading = false
    }
  }

  async created(): Promise<void> {
    try {
      const utms = await this.getUtms()

      this.utms = utms.map(utm => ({
        label: utm.value,
        value: utm.id
      }))

    } catch (e) {
      errorNotificationWrapper(this.$t('error').toString(), e)
    }

    if (this.initUtm) {
      this.setCurrentUtm(this.initUtm)
    } else {
      this.setStat()
    }
  }
}
